import * as Sentry from "@sentry/react";
import { Suspense, type FC, useMemo } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import InlineLoading from "./components/layouts/loading/InlineLoading";
import createRoutes from "./routing/routes";
import useCurrentUser from "./hooks/authentication/useCurrentUser";
import OverlayLoading from "./components/layouts/loading/OverlayLoading";

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

const App: FC = () => {
    const user = useCurrentUser();

    const router = useMemo(() => sentryCreateBrowserRouter(createRoutes(user)), [user]);

    return (
        <Suspense fallback={<OverlayLoading text="Loading..." />}>
            <RouterProvider router={router} />
        </Suspense>
    );
};

export default App;
